import { NgModule } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { AUTHGWCONSTANTS } from './authorization/authconstants';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { Log } from './util/log_util';
import { StaticMemory } from './handler/static_memory';
@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private router: Router) {
    if (localStorage.getItem(AUTHGWCONSTANTS.bearerToken) === null) {
      localStorage.clear();
      sessionStorage.clear();
      StaticMemory.isAuthVerified = false;
      this.router.navigate(['auth/signin']);
    } else {
      Log.i('verified');
      StaticMemory.isAuthVerified = true;
    }
    this.router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        Log.i('[NAV-URL] -> ', event.url);
        sessionStorage.setItem(StaticMemory.xRoute, event.url);
        if (event.url === '/' && StaticMemory.isAuthVerified) {
          this.router.navigate(['pages/dashboard']);
          // this.router.navigate(['pages/service_types']);
        }
      }
    });
  }
}
